<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field label="Fiscal Year">
              <b-input v-model="fiscalYear" type="text" />
            </b-field>
            <b-field label="Inventory Number">
              <b-input v-model="selectedInventory" type="text" />
            </b-field>
            <b-field>
              <b-button
                type="is-success"
                icon-left="save"
                :disabled="isLoading"
                @click="() => {resetData(); getData();}"
              >
                Load
              </b-button>
            </b-field>
          </b-field>
          <b-field label="Plant">
            <div v-if="selectedPlant">
              {{ selectedPlant.id + ' - ' + selectedPlant.name }}
            </div>
          </b-field>
          <b-field v-for="(inventory, index) in inventories" :key="index + 'inventory'">
            <b-field style="background-color: white; align-items: center; display: flex; padding: 0.1rem;" class="ml-2">
              <div style="margin-right: 10px;">
                {{ "Material Name:" }}
              </div>
              <div style="margin-right: 10px;">
                {{ inventory.MatName }}
              </div>
            </b-field>
            <b-field style="background-color: white; align-items: center; display: flex; padding: 0.1rem;" class="ml-2">
              <div style="margin-right: 10px;">
                {{ "Material N°:" }}
              </div>
              <div style="margin-right: 10px;">
                {{ inventory.Material }}
              </div>
            </b-field>
            <b-field class="ml-2">
              <b-input v-model="inventory.qty" type="number" :disabled="inventory.Counted" min="0" step="any" />
            </b-field>
            <b-field style="height: 100%; align-items: center; display: flex; margin-left: 0.3rem;">
              <div style="margin-right: 10px;">
                {{ "Zero?" }}
              </div>
              <b-checkbox v-model="inventory.zero" name="zeroCrates" :disabled="inventory.Counted" />
            </b-field>
          </b-field>
          <b-field>
            <b-button
              type="is-success"
              icon-left="save"
              :disabled="isLoading || !isLoaded"
              @click="() => {isValidating = true}"
            >
              Save
            </b-button>
          </b-field>
        </div>
      </div>
      <b-modal :active.sync="isValidating" scroll="keep" has-modal-card>
        <form v-if="isValidating" @submit.prevent="saveInventory">
          <div class="modal-card" style="min-width: 50vw; width: fit-content; height: fit-content;">
            <header class="modal-card-head" />
            <section class="modal-card-body">
              Are you sure? Submitted inventories cannot be modified.
            </section>
            <footer class="modal-card-foot">
              <button type="submit" class="button is-info is-fullwidth">
                {{ $t('global.submit') }}
              </button>
            </footer>
          </div>
        </form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import sapInventory from '../../../../services/v3/sapInventory'
import plantSelector from '@/mixins/plantSelector'
// import sortAndFilterMixins from '@/mixins/agGridSortAndFilter'

export default {
  name: 'SAPInventory',
  components: {
  },
  mixins: [plantSelector],
  data: function () {
    return {
      isLoading: false,
      isLoaded: false,
      inventories: [],
      fiscalYear: null,
      selectedInventory: null,
      selectedPlant: null,
      isValidating: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted: async function () {
    // The plant comes back from SAP as a storage location, which is exactly what
    // the hidden FRZ* plants are, so this lookup needs the unfiltered list.
    await this.loadPlants({ force: true })
  },
  methods: {
    resetData () {
      this.inventories = []
      this.selectedPlant = null
      this.isValidating = false
    },
    async getData () {
      if (!this.selectedInventory) {
        this.$buefy.toast.open({ message: 'Please enter an inventory number', duration: 3000, type: 'is-danger' })
        return
      }
      this.isLoading = true
      try {
        const data = await sapInventory.get(this.fiscalYear, this.selectedInventory)
        if (data && data.d) {
          this.selectedPlant = this.allPlants.filter(x => x.id === data.d.StgeLoc)[0]
          data.d.InventoryDetailSet.results.forEach(element => {
            this.inventories.push({
              Physinventory: element.Physinventory,
              Fiscalyear: element.Fiscalyear,
              Item: element.Item,
              Material: element.Material,
              MatName: element.MatName,
              Plant: element.Plant,
              StgeLoc: element.StgeLoc,
              CountUser: element.CountUser,
              CountDate: element.CountDate,
              Counted: element.Counted,
              DiffPosted: element.DiffPosted,
              Recount: element.Recount,
              DeleteInd: element.DeleteInd,
              ZeroCount: element.ZeroCount,
              EntryQnt: element.EntryQnt,
              EntryUom: element.EntryUom,
              qty: parseFloat(element.EntryQnt),
              zero: element.ZeroCount
            })
          })
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.$buefy.toast.open({ message: 'No Data found', duration: 3000, type: 'is-danger' })
        }
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
        this.isLoading = false
      }
      if (this.inventories && this.inventories.length > 0) {
        this.isLoaded = true
      }
      this.isLoading = false
    },
    async saveInventory () {
      try {
        let finalInventories = this.inventories.filter((x) => {
          return !x.Counted
        }).map((x) => {
          return {
            Physinventory: x.Physinventory,
            Fiscalyear: x.Fiscalyear,
            Item: x.Item,
            Material: x.Material,
            ZeroCount: x.zero,
            EntryQnt: parseFloat(x.qty) === 0 && x.zero ? null : x.qty
          }
        })
        finalInventories = finalInventories.filter((x) => {
          return (x.ZeroCount === true || x.EntryQnt > 0)
        })
        if (finalInventories.length > 0) {
          await sapInventory.saveInventory(finalInventories)
        }
        this.$buefy.toast.open({ message: 'Saved', duration: 3000, type: 'is-success' })
        this.resetData()
        this.getData()
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    }
  }
}

</script>
